import { useQueryClient } from '@tanstack/react-query';
import { BLOCK_LIST_QUERY_KEY } from '../block';
export function createTriggerRepository(config) {
    const { repository, client } = config;
    function getFindKey() {
        return ['research', 'trigger', 'find'];
    }
    return {
        useCreate(context) {
            const queryClient = useQueryClient();
            return repository.useMutation(context, {
                async mutationFn(props) {
                    const response = await client.user.default.triggerCreate({
                        triggerCreatePayload: props,
                    });
                    return response.data;
                },
                async onSuccess(data) {
                    const queryKey = getFindKey();
                    await queryClient.refetchQueries({ queryKey: BLOCK_LIST_QUERY_KEY });
                },
            });
        },
    };
}
//# sourceMappingURL=triggerRepository.js.map